import React from 'react';
import {getStatusColor} from "../helpers";

const StatusBadge = ({statut}: { statut: string }) => {
  if (!statut) return null;

  return (
    <span className={`inline-flex px-2.5 mr-1 text-xs font-medium rounded-full ${getStatusColor(statut)}`}>
      {statut}
    </span>
  );
};

export default StatusBadge;